export default __webpack_public_path__ + "static/media/icon-flag.cc5b46e4.svg";